import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { PageHeader } from "../components/common";
import { ActivityTimeline } from "../components/panels";
import { Input } from "../components/ui/input";

export default function Actividad() {
  const [q, setQ] = React.useState("");
  const { data: items, isLoading } = useQuery({
    queryKey: ["activity-global"],
    queryFn: async () => (await api.get("/activity", { params: { limit: 200 } })).data,
  });

  const filtered = (items || []).filter((a) => !q || a.detail?.toLowerCase().includes(q.toLowerCase()) || a.action?.includes(q.toLowerCase()));

  return (
    <div data-testid="actividad-page">
      <PageHeader title="Actividad" subtitle="Histórico cronológico y auditado de todo el workspace. Los registros no pueden editarse ni eliminarse." />
      <Input placeholder="Filtrar por texto o tipo de evento…" value={q} onChange={(e) => setQ(e.target.value)} className="mb-4 h-8 max-w-md" data-testid="activity-filter-input" />
      <div className="ts-card p-5">
        {isLoading ? <p className="py-10 text-center text-sm text-slate-500">Cargando actividad…</p> : (
          <>
            <p className="ts-caption mb-4">{filtered.length} eventos</p>
            <ActivityTimeline items={filtered} testid="global-activity-timeline" />
          </>
        )}
      </div>
    </div>
  );
}
